/*
 * -----------------------------------------------------------------------
 *  <copyright file="button.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import MUIButton from '@mui/material/Button';
import React from 'react';
import { useTranslation } from 'hooks';
import './styles.scss';
import { textToId } from '@utils/automation-test-helpers';

interface IButtonProps {
    id?: string;
    size?: 'small' | 'medium' | 'large';
    secondary?: boolean;
    menuItems?: [string];
    style?: any;
    onClick?: any;
    component?: any;
    disabled?: boolean;
    children?: any;
    text?: string | null;
    fullWidth?: boolean;
    className?: string;
    type?: string;
    outlined?: boolean;
    borderBtn?: boolean;
    'data-testid'?: string;
}

const Button = ({
    id,
    secondary,
    fullWidth,
    size,
    style,
    text,
    children,
    onClick,
    disabled,
    component,
    className,
    menuItems,
    type,
    outlined,
    borderBtn,
    'data-testid': dataTestId,
}: IButtonProps) => {
    const { t } = useTranslation();

    return (
        <MUIButton
            id={id}
            data-testid={dataTestId ?? id ?? `button-${textToId(text ?? '')}`}
            variant={outlined ? 'text' : borderBtn ? 'outlined' : 'contained'}
            className={className}
            color={secondary ? 'secondary' : borderBtn ? 'inherit' : 'primary'}
            component={component}
            disabled={disabled}
            fullWidth={fullWidth}
            onClick={onClick}
            size={size}
            style={style}
            type={type}
            disableRipple
        >
            {text ? (text[0] === '@' ? text.substr(1) : t(text)) : children}
        </MUIButton>
    );
};

export default Button;
